function validateURL(data) {
    try {
        return Boolean(new URL(data))
    } catch(err) {
        return false
    }
}
export default validateURL